import Joi from "@hapi/joi";

export default {
    username: {
        fieldName: "username",
        defaultValue: "",
        validation: Joi.string()
            .required()
            .label("Username"),
        render: {
            type: "input",
            configuration: {
                label: "Username",
                autofocus: true
            }
        }
    },
    password: {
        defaultValue: "",
        validation: Joi.string()
            .required()
            .label("Password"),
        render: {
            type: "input",
            configuration: {
                type: "password",
                label: "Password",
                help: "Password is case-sensitive"
            }
        }
    }
}